import { render } from "./TariffsFtlCreate.vue?vue&type=template&id=6859b52a&scoped=true&ts=true"
import script from "./TariffsFtlCreate.vue?vue&type=script&lang=ts"
export * from "./TariffsFtlCreate.vue?vue&type=script&lang=ts"

import "./TariffsFtlCreate.vue?vue&type=style&index=0&id=6859b52a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6859b52a"]])

export default __exports__